import React from 'react';
import './GridPageContent.css';
import { GridPageStrip } from '../GridPageStrip';
import { GridPageStripType } from '../GridPageStripType';

const buildStripsToRender = (gridPage, categories) => {
    const originalStrips = gridPage?.gridStrips || [];
    const numberOfCategoryStrips = originalStrips
        .filter(({ stripType }) => stripType === GridPageStripType.GAMES_CATEGORY)
        .length;
    const stripsToRender = [...originalStrips];
    const numberOfStripsToAdd = categories.length - numberOfCategoryStrips;
    if (numberOfStripsToAdd > 0) {
        const stripsToAdd = new Array(numberOfStripsToAdd);
        const stripTemplate = {
            stripType: GridPageStripType.GAMES_CATEGORY,
            designType: gridPage.defaultDesignType,
        };
        stripsToAdd.fill(stripTemplate);
        stripsToRender.splice(stripsToRender.length, 0, ...stripsToAdd);
    }

    return stripsToRender;
};

const renderStrips = ({
    gridPage,
    categories,
    setCurrentSubcategoryId,
}) => {
    const indexPerType = {};
    let isWinnersStripExists = false;
    const stripsToRender = buildStripsToRender(gridPage, categories);

    const renderedStrips = stripsToRender.map(
        (strip, index) => {
            const { stripType } = strip;
            const typedIndex = indexPerType[stripType] === undefined ? 0 : indexPerType[stripType] + 1;
            indexPerType[stripType] = typedIndex;

            if (stripType === GridPageStripType.WINNERS) {
                isWinnersStripExists = true;
            }

            // strip doesn't have it's own ID, but sonar forces not to use array's index
            const key = JSON.stringify({ index, strip });

            return <GridPageStrip
                key={key}
                strip={strip}
                typedIndex={typedIndex}
                categories={categories}
                setCurrentSubcategoryId={setCurrentSubcategoryId}
            />;
        }
    );

    return {
        renderedStrips,
        isWinnersStripExists,
    };
};

export const GridPageContent = (props) => {
    const stripsData = renderStrips(props);

    return (
        <div className="grid-page-content">
            <div className="grid-page-content-inner">
                {stripsData.renderedStrips}

                {/*Add Winners strip to its default place if it is not configured*/}
                {!stripsData.isWinnersStripExists && <GridPageStrip
                    strip={{ stripType: GridPageStripType.WINNERS }}
                />}
            </div>
        </div>
    );
};
